import { Controller } from "@hotwired/stimulus";
import { SCRATCH_TYPE, ScratchCard } from "scratchcard-js";

export default class extends Controller {
    static get values() {
        return {
            coverImage: String
        }
    }
    static get targets() {
        return ["scratchcardContainer", "resultContainer", "confetti", "revealButton", "completeButton"];
    }

    showResult() {
        setTimeout(
            () => {
                this.scratchcardContainerTarget.style.userSelect = "auto";
                this.resultContainerTarget.classList.remove("d-none");

                if (this.hasConfettiTarget) {
                    this.confettiTarget.classList.remove("d-none");
                }

                this.revealButtonTarget.classList.add("d-none");
                this.completeButtonTarget.classList.remove("d-none");
            },
            250
        );
    }

    async renderScratchcard() {

        this.scratchcardContainerTarget.scratchCard = new ScratchCard(
            this.scratchcardContainerTarget,
            {
                callback: () => this.showResult(),
                clearZoneRadius: 50,
                containerHeight: this.scratchcardContainerTarget.offsetHeight,
                containerWidth: this.scratchcardContainerTarget.offsetWidth,
                imageForwardSrc: this.coverImageValue,
                imageBackgroundSrc: '',
                htmlBackground: `<div></div>`,
                scratchType: SCRATCH_TYPE.LINE
            }
        );
        await this.scratchcardContainerTarget.scratchCard.init();
        this.scratchcardContainerTarget.style.opacity = 1;
    }

    reveal() {
        this.scratchcardContainerTarget.scratchCard.clear();
        this.showResult();
    }
}